import { sdGatewayClient } from '../http/sdGatewayClient';
import { AccountGroup } from '../models/AccountGroup';
import { AccountGroupSellerNumberExpanded } from '../models/AccountGroupSellerNumber';
import { deepCamelCase } from '../utils/camelCase';
import { deepSnakeCase } from '../utils/snakeCase';

type listingOption = {
  name: string;
  display: string;
};

/**
 * Account Group Service
 *
 * Lives in the SD Rails API
 * https://ghe.coxautoinc.com/SellerTools/seller_dashboard/tree/master/app/controllers/api/account_groups_controller.rb
 */
export const accountGroupService = {
  async search(query?: { sellerNumbers?: Array<number | string>; username?: string }) {
    return deepCamelCase<AccountGroup[]>(
      await (
        await sdGatewayClient.post('/seller-dashboard/api/account_groups/search', query && deepSnakeCase(query))
      ).data
    );
  },

  /**
   * Fetch listing manager display config for current account group from legacy SD database
   * @param accountGroupId
   * @returns array of enabled listing options for Listing Manager
   */
  async getListingOptions(accountGroupId: string): Promise<string[]> {
    const response = await sdGatewayClient.get(`/seller-dashboard/api/listing_options_config?id=${accountGroupId}`);
    const responseArray: listingOption[] = Object.values(response.data);
    return responseArray.filter(item => item.display === 'visible').map(item => item.name);
  },
  async getById(_id: string | number): Promise<AccountGroup> {
    throw new Error('accountGroupService.getById is not implemented yet');
  },

  async create(_accountGroup: Partial<AccountGroup>) {
    throw new Error('accountGroupService.createAccountGroup is not implemented yet');
  },

  async update(_accountGroup: Partial<AccountGroup>) {
    throw new Error('accountGroupService.getById is not implemented yet');
  },

  async getSellerNumbers(_accountGroupId: number): Promise<AccountGroupSellerNumberExpanded[]> {
    throw new Error('accountGroupService.getSellerNumbers is not implemented yet');
  },

  async setSellerNumbers(_accountGroupId: number, _sellerNumbers: number[]) {
    throw new Error('accountGroupService.setSellerNumbers is not implemented yet');
  },

  async deleteSellerNumber(_sellerNumberId: number) {
    throw new Error('accountGroupService.deleteSellerNumber is not implemented yet');
  }
};
